import React from "react";
import "./ContentTableOfContents.scss";

export interface IContentTableOfContentsLink {
  title: string;
  slug: string;
  isChild: boolean;
}

export interface IContentTableOfContentsProps {
  title: string;
  anchors: IContentTableOfContentsLink[] | null;
}

const ContentTableOfContents = ({ title, anchors }: IContentTableOfContentsProps): JSX.Element => {
  /**
   * 
   */
  const getAnchors = (): JSX.Element[] | null => {
    if (!anchors) {
      return null;
    }

    const links: JSX.Element[] = [];

    for (let index = 0; index < anchors.length; index++) {
      const link = anchors[index];
      const childClass = link.isChild ? " ContentTableOfContents__linkContainer--child" : "";

      links.push(
        <div key={index} className={`ContentTableOfContents__linkContainer${childClass}`}>
          <a className="ContentTableOfContents__link" href={`#${link.slug}`}>{link.title}</a>
        </div>
      );
    }

    return links;
  };
  
  return (
    <div className="ContentTableOfContents">
      <div className="ContentTableOfContents__title">{title}</div>
      {getAnchors()}
    </div>
  );
};
export default ContentTableOfContents;